// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3fad5410","27":"f28bbcf4","174":"e859d109","216":"f6ebe225","272":"f76fd9fa","281":"6e4889c0","310":"2f98985f","432":"43520701","627":"c0a44d29","675":"559cb274","778":"24be8117","788":"01d8f59c"}[chunkId] + ".chunk.js";
};